// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"invoiceReceiving_formitemRow__1uvpI"};